/*
 *   Infobar
 */

$class: ".gov-infobar";

#{$class} {
	@include base();

	&__section {
		display: flex;
		gap: rem-calc(16);
		padding: rem-calc(16);
	}

	&__icon {
		flex: 0 0 auto;

		& > * {
			width: rem-calc(20);
			height: rem-calc(20);
		}
	}

	&__headline {
		display: flex;
		gap: rem-calc(16);

		+ div {
			margin-top: rem-calc(8);
		}

		p {
			margin-bottom: 0;
		}

		gov-button {
			margin-top: rem-calc(-4);
		}
	}

	&__content {
		@include reset-last-margin();
		width: 100%;

		&--closable {
			padding-right: rem-calc(56);
		}

		p {
			@include typography($font-size-m);
		}

		a {
			color: inherit;
			@include hover() {
				color: inherit;
			}
			.gov-icon {
				color: inherit;
			}
		}
	}

	&__close {
		position: absolute;
		top: rem-calc(14);
		right: rem-calc(16);
	}

	// VARIANTS
	@each $variant, $definitions in $infobar-variants {
		&[variant="#{$variant}"] {
			background-color: get("bg-color", $definitions);

			#{$class} {
				&__icon {
					color: get("icon-color", $definitions);
				}

				&__content {
					color: get("text-color", $definitions);
				}
			}

			@if deep-map-check($definitions, "border") {
				border-bottom: $infobar-border;
			}

			// STATES
			@include parameter("inverse") {
				border-bottom: $infobar-border;
				background-color: $infobar-inverse-bg;
				#{$class} {
					&__icon {
						color: get("bg-color", $definitions);
					}

					&__content {
						color: $infobar-inverse-color;
					}
				}
			}
		}
	}
}
